var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLupe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6096 13.7274L12.513 10.6308C13.4559 9.21934 13.84 7.50766 13.5908 5.82866C13.3415 4.14967 12.4767 2.62341 11.1644 1.54678C9.85215 0.470139 8.18635 -0.0798974 6.49101 0.00365609C4.79567 0.0872095 3.19202 0.798379 1.99199 1.99883C0.791967 3.19928 0.0813646 4.80318 -0.00158949 6.49855C-0.0845436 8.19392 0.466082 9.85953 1.54318 11.1714C2.62028 12.4833 4.14684 13.3476 5.82593 13.5963C7.50501 13.8449 9.21656 13.4601 10.6276 12.5168L13.7243 15.6128C13.9765 15.8587 14.3147 15.9964 14.667 15.9964C15.0192 15.9964 15.3575 15.8587 15.6096 15.6128C15.8596 15.3627 16 15.0236 16 14.6701C16 14.3165 15.8596 13.9775 15.6096 13.7274ZM6.83365 2.00343C7.78959 2.00343 8.72407 2.2869 9.5189 2.81799C10.3137 3.34909 10.9332 4.10395 11.2991 4.98713C11.6649 5.8703 11.7606 6.84213 11.5741 7.7797C11.3876 8.71728 10.9273 9.57849 10.2513 10.2544C9.57538 10.9304 8.71416 11.3907 7.77658 11.5772C6.83901 11.7637 5.86719 11.668 4.98401 11.3022C4.10083 10.9364 3.34597 10.3169 2.81488 9.52202C2.28378 8.72718 2.00031 7.79271 2.00031 6.83676C2.00172 5.55532 2.5114 4.32676 3.41752 3.42064C4.32364 2.51452 5.5522 2.00484 6.83365 2.00343Z",
    fill: "#505887",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupe);
export default __webpack_public_path__ + "static/media/lupe.75e4a07c3bf4c85527bc5b5b5c346ab4.svg";
export { ForwardRef as ReactComponent };